export default "__VITE_ASSET__D4ElHQ8P__"